<template>
    <el-form :model="yqInfo" ref="yqInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required" v-if="cronFlag != null && cronFlag && !viewFlag">首次工单截止时间</label>
                    <label class="required" v-else-if="cronFlag != null && cronFlag && viewFlag">下次工单截止时间</label>
                    <label class="required" v-else>工单截止时间</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="yqFinishTime" :rules="{validator: checkNull, trigger: 'blur'}">
                        <el-date-picker v-model="yqInfo.yqFinishTime" :picker-options="pickerOptions0" type="datetime" placeholder="请选择" @change="yqFinishTimeChange"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="cronFlag != null && cronFlag">
                <div class="form-label">
                    <label class="required">要求完成小时</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{yqInfo.yqFinishHours}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">提前预警小时</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="yqFinishAotHr" :rules="{validator: inputYqFinishAotHr, trigger: 'blur'}">
                        <el-input type="number" min="1" class="input-content-right" v-model="yqInfo.yqFinishAotHr"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    //
    export default {
        name: 'swb-plan-yq-info',
        avlScopes: 'retailer',
        desc: '设置要求信息',
        props: {
            planType: {
                type: String,
                default: null
            },
            viewFlag: {
                type: Boolean,
                default: false
            },
            cronFlag: {
                type: Boolean,
                default: null
            },
            theDateTime: {
                type: Date,
                default: null
            }
        },
        data: function () {
            return {
                yqInfo: {
                    yqFinishTime: null,
                    yqFinishHours: null,
                    yqFinishAotHr: null,
                },
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        created: function () {
        },
        methods: {
            // 校验
            checkNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            // 预警小时校验
            inputYqFinishAotHr: function (rule, value, callback) {
                let yqFinishTime = this.yqInfo.yqFinishTime;
                if(Utils.isNoB(yqFinishTime)) {
                    this.yqInfo.yqFinishAotHr = null;
                    callback(new Error('请先设置工单截止时间'));
                } else {
                    if(!Utils.isIntStr(value) || value <= 0) {
                        this.yqInfo.yqFinishAotHr = null;
                        callback(new Error('预警小时应为正整数！'));
                    } else {
                        callback();
                    }
                }
            },
            // 工单截止时间设置
            yqFinishTimeChange: function () {
                let yqFinishTime = this.yqInfo.yqFinishTime;
                if(!Utils.isNoB(yqFinishTime)) {
                    if(!Utils.isTrue(this.cronFlag) && Utils.isNoB(this.theDateTime)) {
                        MsgBox.warning("请先设置" + this.planType + "时间");
                        return false;
                    } else {
                        if(yqFinishTime < this.theDateTime) {
                            this.yqInfo.yqFinishTime = null;
                            MsgBox.warning("工单截止时间要晚于" + this.planType + "时间");
                            return false;
                        } else {
                            if(Utils.isTrue(this.cronFlag)) {
                                //时间差的毫秒数
                                let times = yqFinishTime.getTime() - this.theDateTime.getTime();
                                let hours = Math.round(times / (3600 * 1000));
                                this.yqInfo.yqFinishHours = Utils.merge(null, hours);
                            }
                        }
                    }
                }
            },
            // 保存设备保养计划
            getDlgResult: function () {
                let yqInfo = this.yqInfo;
                //
                let result = {};
                this.$refs['yqInfo'].validate(function (valid) {
                    if(valid) {
                        //
                        result.type = 'info';
                        result.data = yqInfo;
                    } else {
                        result.message = "请设置相应的要求信息";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/PlanYqInfo.vue